<template>
  <div id="app">
    <header-content  :info="info"></header-content>
    <router-view />
    <footer-content></footer-content>
  </div>
</template>

<script>
import headerContent from './components/common/headerContent'
import footerContent from './components/common/footerContent'
// import { postService } from "@/api/service";
export default {
  data() {
    return {
      info: {}
    }
  },
  name: 'App',
  components: {
    headerContent,
    footerContent
  },
  mounted() {
    // postService('api/index/details', { page: 1, limit: 1 }).then(result => {
    //   this.info = result.data.data.rows[0];


    // }).catch(err => {
    //   console.log(err)
    // })
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  min-width: 1400px;
  overflow-x: auto;
  overflow-x: hidden;
}

.ql-align-center{
  text-align: center !important;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

.banner {
  min-height: 400px;
  display: block;
  width: 100%;
  /* opacity: 0;
  animation: fade-in 1s forwards;
  transform: scale(1.05);
  filter: blur(5px); */
}

@keyframes fade-in {
  0% {
    opacity:0;
    transform: scale(1.05);
    filter: blur(5px);
  }


  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue